import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { ReactWidget } from "../../Interfaces";
import { ContainedSection } from "../../apella/EventPage";
import RegistrationForm from "../registrationForm/RegistrationForm";
import { getTranslations } from "../../../../translations/Translations";

const RegistrationFormWidget = ({ widget, pageConfig }: ReactWidget) => {
  const translations = getTranslations();
  const config = widget.config || {};

  const textAlign = config["textAlign"];

  if (pageConfig && typeof pageConfig.showEventPlan !== "undefined") {
    config.showEventPlan = pageConfig.showEventPlan;
  }

  const styles: any = {};
  if (textAlign) {
    styles.textAlign = textAlign;
  }

  return (
    <ContainedSection id="anmelden">
      <Grid item md={12}>
        <Typography
          variant="h2"
          textAlign={"center"}
          sx={{ hyphens: "auto", wordBreak: "break-word" }}
        >
          {translations["event.website.page.registerTitle"]}
        </Typography>
      </Grid>
      <Box>
        <RegistrationForm
          eventId={widget.eventId}
          registrationWidgetId={Number(widget.id)}
          config={config}
        />
      </Box>
    </ContainedSection>
  );
};

export default RegistrationFormWidget;
